import React from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    container: {
        width: '100%',

    },

    typo: {
        whiteSpace: 'pre-wrap',
    },

    imgContainer: {
        margin: "0px auto",
        "@media(max-width:440px)": {
            maxWidth: "300px",
            display: "flex",
            flexDirection: "row",
            flexWrap: "no-wrap",
            overflowX: "auto",

        }
    },

    img: {
        width: "200px",
        height: "200px",
        "@media(max-width:770px)": {
            width: "300px",
            height: "300px",
        }
    }
}));


const Notice = ({ title, content, date, image_urls, author }) => {

    const styles = useStyles();




    return (

        <Accordion className={styles.container}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
            >
                <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography component="p" paragraph={true} className={styles.typo}>
                    {date} / {author}
                    <br />
                    {content}
                    <br />
                    <div className={styles.imgContainer}>
                        {image_urls.map(image_url => (
                            <img src={image_url} alt={title} className={styles.img} />
                        ))}
                    </div>
                </Typography>

            </AccordionDetails>
        </Accordion>

    );
};

export default Notice;